import React from 'react'
import './Experience.css'

// Front-End Icons
import {MdHtml} from "react-icons/md";
import {MdCss} from "react-icons/md";
import {MdJavascript} from "react-icons/md";
import {FaBootstrap} from "react-icons/fa";
import {DiJqueryLogo} from "react-icons/di";
import {FaReact} from "react-icons/fa";

// Back-End Icons
import {FaPhp} from "react-icons/fa";
import {FaLaravel} from "react-icons/fa";
import {FaPython} from "react-icons/fa";
import {SiDjango} from "react-icons/si";
import {SiCplusplus} from "react-icons/si";
import {SiMysql} from "react-icons/si";

export default function Experience() {
  return (
    <>
        <section id='experience'>
            <div id='experience-container'>
                <div className='experience-headline'>
                    <p> See Through My </p>
                    <h1> Experience </h1>
                </div>

                <div className='experience-content'>
                    <div id='front-end' className="experience-box">
                        <div className="experience-box-headline">
                            <h1> Front-End Development </h1>
                        </div>

                        <div className='experience-box-content'>
                            <div id='html' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <MdHtml/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> HTML </h3>
                                    <p> Experienced </p>
                                </div>
                            </div>

                            <div id='css' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <MdCss/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> CSS </h3>
                                    <p> Experienced </p>
                                </div>
                            </div>

                            <div id='javascript' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <MdJavascript/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> Javascript </h3>
                                    <p> Experienced </p>
                                </div>
                            </div>

                            <div id='bootstrap' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <FaBootstrap/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> Bootstrap </h3>
                                    <p> Intermediate </p>
                                </div>
                            </div>

                            <div id='jquery' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <DiJqueryLogo/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> jQuery </h3>
                                    <p> Beginner </p>
                                </div>
                            </div>
                            
                            <div id='react' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <FaReact/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> ReactJS </h3>
                                    <p> Intermediate </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id='back-end' className="experience-box">
                        <div className="experience-box-headline">
                            <h1> Back-End Development </h1>
                        </div>

                        <div className='experience-box-content'>
                            <div id='php' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <FaPhp/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> PHP </h3>
                                    <p> Beginner </p>
                                </div>
                            </div>

                            <div id='laravel' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <FaLaravel/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> Laravel </h3>
                                    <p> Beginner </p>
                                </div>
                            </div>

                            <div id='python' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <FaPython/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> Python </h3>
                                    <p> Intermediate </p>
                                </div>
                            </div>

                            <div id='django' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <SiDjango/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> Django </h3>
                                    <p> Intermediate </p>
                                </div>
                            </div>

                            <div id='c++' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <SiCplusplus/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> C++ </h3>
                                    <p> Intermediate </p>
                                </div>
                            </div>

                            <div id='mysql' className="experience-cards">
                                <div className='experience-cards-logo'>
                                    <span>
                                        <SiMysql/>
                                    </span>
                                </div>

                                <div className="experience-cards-text">
                                    <h3> MySQL </h3>
                                    <p> Beginner </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
